export default function BasicFooterDocumentos ({textBack, onClickBack, textNext, onClickNext, imgNext, imgBack, emitirNuevo, onEmitirNuevo} : {textBack: any, onClickBack: () => void, textNext: string, onClickNext: () => void, imgNext: string, imgBack: string, emitirNuevo?:any, onEmitirNuevo?: any}){

    return (
        <>
        <div className='form-separator'></div>
        <div className='w-layout-hflex button-actions'>
          {textBack &&
          <button className='m button transparent botton-footer' onClick={onClickBack}>
            {imgBack &&
              <img src={imgBack} loading='lazy' alt='Back' />
            }
            <div>{textBack}</div>
          </button>
          }
          <div style={{width: '65%'}}></div>
          <button className='m button botton-footer' onClick={onClickNext}>
            <div>{textNext}</div>
            <img src={imgNext} loading='lazy' alt='Next' />
          </button>
          {emitirNuevo &&
          <button className='m button botton-footer' onClick={onEmitirNuevo}>
            <div>{emitirNuevo}</div>
          </button>
          }
        </div>
      </>
    )
}